var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.fn_IS_MOBILE())?_c('Accordion',{attrs:{"categories":_vm.categories,"loading":_vm.loading}}):_c('MobileAccordion',{attrs:{"daysView":_vm.daysView,"categories":_vm.categories,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }